module.exports = __webpack_public_path__ + "static/media/GBR Tech (CBN Network) - GBR Tech - 14-05-2024 N.5a7f8565.gif";